import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "base-select__label" }
const _hoisted_2 = {
  key: 0,
  class: "base-select__dropdown"
}
const _hoisted_3 = ["onClick"]

import { computed, onMounted, onUnmounted, ref } from "vue";
import BaseIcon from "@/components/ui/BaseIcon.vue";

export interface SelectOption {
  label: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSelect',
  props: {
    modelValue: {},
    options: {},
    icon: {},
    width: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const open = ref(false);
const containerRef = ref<HTMLElement | null>(null);

const selectedLabel = computed(
  () =>
    props.options.find((o) => o.value === props.modelValue)?.label ??
    props.options[0]?.label
);

function select(value: string) {
  emit("update:modelValue", value);
  open.value = false;
}

function handleOutsideClick(e: MouseEvent) {
  if (containerRef.value && !containerRef.value.contains(e.target as Node)) {
    open.value = false;
  }
}

onMounted(() => document.addEventListener("mousedown", handleOutsideClick));
onUnmounted(() =>
  document.removeEventListener("mousedown", handleOutsideClick)
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: "base-select"
  }, [
    _createElementVNode("button", {
      class: _normalizeClass(["base-select__trigger", { 'base-select__trigger--open': open.value }]),
      style: _normalizeStyle(__props.width ? { width: __props.width } : {}),
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value))
    }, [
      (__props.icon)
        ? (_openBlock(), _createBlock(BaseIcon, {
            key: 0,
            name: __props.icon,
            size: 14,
            class: "base-select__icon"
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_1, _toDisplayString(selectedLabel.value), 1),
      _createVNode(BaseIcon, {
        name: "chevron-down",
        size: 12,
        class: _normalizeClass(["base-select__chevron", { 'base-select__chevron--open': open.value }])
      }, null, 8, ["class"])
    ], 6),
    _createVNode(_Transition, { name: "dropdown" }, {
      default: _withCtx(() => [
        (open.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: option.value,
                  type: "button",
                  class: _normalizeClass(["base-select__option", {
            'base-select__option--active': option.value === __props.modelValue,
          }]),
                  onClick: ($event: any) => (select(option.value))
                }, [
                  (option.value === __props.modelValue)
                    ? (_openBlock(), _createBlock(BaseIcon, {
                        key: 0,
                        name: "check",
                        size: 12,
                        class: "base-select__check"
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    style: _normalizeStyle(option.value !== __props.modelValue ? { paddingLeft: '20px' } : {})
                  }, _toDisplayString(option.label), 5)
                ], 10, _hoisted_3))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})